<template>
    <div class="doc-section">
        <h1>Restablecer contraseña</h1>
        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            En la tabla de usuarios, hacer clic sobre el botón de restablecer contraseña, el sistema mostrará una
            ventana emergente con el mensaje Esta seguro que, ¿Desea asignar una contraseña temporal? El usuario deberá
            asignar una contraseña nueva al iniciar sesión, hacer clic en el botón “Aceptar” para asignar una contraseña
            temporal al usuario o en “Cancelar” para no asignar una contraseña temporal al usuario.
        </p>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseña[0]]" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseñaMoviles[0]]" />
        </div>

        <h2>Copiar contraseña temporal</h2>
        <p>
            Al asignar una contraseña temporal al usuario exitosamente se mostrará una notificación en el centro del
            sistema. Copiar la contraseña temporal al portapapeles.
        </p>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseña[1]]" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseñaMoviles[1]]" />
        </div>


        <h2>Iniciar sesión con contraseña temporal</h2>
        <p>
            Se debe iniciar sesión con el nombre de usuario asociado a la contraseña temporal, asegurándose de haber
            copiado previamente dicha clave en el portapapeles.
        </p>

        <h2>Restrablecer contraseña</h2>
        <p>Vista para restablecer contraseña.</p>
        <ul class="ul-contenedor step-list">
            <li>a) Nueva contraseña, remplazar valor con el que inicia sesión el usuario.</li>
            <li>b) Confirmación de contraseña, valor que debe coincidir con la nueva contraseña introducida
                anteriormente.</li>
        </ul>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseña[2]]" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="[imagenesRestablecerContraseñaMoviles[2]]" />
        </div>

        <div class="info-card">
            
            <p><strong>Nota:</strong> Al realizar los pasos correctamente, se redirigirá a la pantalla de <strong>Monitoreo</strong>.</p>
        </div>

    </div>
</template>


<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'restablecerContraseña',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesRestablecerContraseña: [
            {
                nombre: "",
                url: "img/usuarios/restablecerContraseña.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/usuarios/copiarContraseñaTemp.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/usuarios/nuevaContraseña.png",
                descripcion: "Desactivación de marcadores en mapa"
            }
        ],
        imagenesRestablecerContraseñaMoviles: [
            {
                nombre: "",
                url: "img/usuarios/moviles/restablecerContraseña.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/usuarios/moviles/copiarContraseñaTemp.png",
                descripcion: ""
            },
            {
                nombre: "",
                url: "img/usuarios/moviles/nuevaContraseña.png",
                descripcion: "Desactivación de marcadores en mapa"
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>